import { PublicKey, clusterApiUrl } from '@solana/web3.js';

// Environment-based configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// Solana RPC URL
export const SOLANA_RPC_URL = process.env.REACT_APP_SOLANA_RPC_URL ||
  (isDevelopment ? 'http://localhost:8899' : clusterApiUrl('devnet'));

// Program ID
export const PROGRAM_ID = new PublicKey('3aydJWNqyEn5NUBqqi14hvTgaj8HX8kbmzmgUP9jWzZk');

// Token decimals
export const TOKEN_DECIMALS = 9;
export const DISPLAY_DECIMALS = 2;

// Slots per day (assuming ~400ms per slot)
export const SLOTS_PER_DAY = 216000;

// Airdrop cooldown in slots (~1 day)
export const AIRDROP_COOLDOWN_SLOTS = SLOTS_PER_DAY;

// Address Lookup Table for game transactions (reduces tx size)
// Set to null until created via admin script, then set the address
export const GAME_LOOKUP_TABLE: PublicKey | null = new PublicKey('9BuCEp5PfPUWYYafnEKTTyriiQX7Dkm35nmCrxPsEpgY');
